import { atom } from 'jotai'
import type { TicketOption } from '@/core/components/home/ticket.types'

export const ticketOptionsAtom = atom<TicketOption[]>([])

export const isLoadingTicketOptionsAtom = atom<boolean>(false)

export const ticketOptionsErrorAtom = atom<string | null>(null)

export const hasLoadedTicketOptionsAtom = atom<boolean>(false)
